import Image from 'next/image';

import './CoursesOverview.scss';
import { Slider } from '@components';
import icons from '@assets/icons/redesign';
import { insertSoftHyphen } from '@helpers/styles';

const { Star, StarStroke } = icons;

export default function CoursesOverview({ title, subtitle, courses }) {
  return (
    <section className="coursesOverview">
      <div className="coursesOverview-header">
        <h2
          className="coursesOverview-title"
          dangerouslySetInnerHTML={{
            __html: insertSoftHyphen(
              title,
              'zwangerschapscursussen',
              'zwangerschaps&shy;cursussen'
            )
          }}
        />
        <p className="coursesOverview-subtitle">{subtitle}</p>
      </div>

      <div className="coursesOverview-list">
        <Slider
          slides={courses.map((course) => (
            <CourseCard key={course.title} course={course} />
          ))}
        />
      </div>
    </section>
  );
}

function CourseCard({ course: { title, imageSrc, imageAlt, list, link } }) {
  return (
    <div className="coursesOverview-course-card">
      <a href={link} target="_blank">
        <Image
          src={imageSrc}
          alt={imageAlt}
          className="coursesOverview-course-card-img"
          sizes="(min-width: 1200px) 40vw, 80vw"
          placeholder="blur"
        />
      </a>

      <div className="coursesOverview-course-card-body">
        <div className="coursesOverview-course-card-header">
          <h3 className="coursesOverview-course-card-title">
            <a href={link} target="_blank">
              {title}
            </a>
          </h3>
          <div className="coursesOverview-course-card-stars">
            {Array(5)
              .fill(null)
              .map((_, i) => (
                <Star
                  key={i}
                  className="coursesOverview-course-card-star-icon"
                />
              ))}
          </div>
        </div>

        <ul className="coursesOverview-course-card-list">
          {list.map((item, idx) => (
            <li className="coursesOverview-course-card-list-item" key={idx}>
              <StarStroke className="coursesOverview-course-card-list-item-icon" />
              {item}
            </li>
          ))}
        </ul>

        <a
          href={link}
          target="_blank"
          className="coursesOverview-course-card-button"
        >
          Bekijk cursus
        </a>
      </div>
    </div>
  );
}
